import React from 'react';

import { SimpleInfo } from '~/components';

import { Grid } from './AdditionalInfo.styled';

const MARITAL_STATUS_MAP: Record<string, string> = {
  MARRIED: 'Casado',
  SEPARATED: 'Separado',
  DIVORCED: 'Divorciado',
  SINGLE: 'Solteiro',
  WIDOWER: 'Viúvo',
};

type PersonData = {
  street?: string;
  addressNumber?: string;
  zipCode?: string;
  district?: string;
  city?: string;
  state?: string;
  addressComplement?: string;
  income?: string;
  maritalStatus?: string;
};

export type AdditionalInfoProps = {
  person?: PersonData;
};

export function AdditionalInfo({ person }: AdditionalInfoProps) {
  const logradouro =
    person?.street || person?.addressNumber
      ? `${person?.street || 'Não Informado'}, ${person?.addressNumber || 'S/N'}`
      : 'Não Informado';

  const maritalStatus = person?.maritalStatus
    ? MARITAL_STATUS_MAP[person.maritalStatus] ?? 'Não Informado'
    : 'Não Informado';

  return (
    <Grid>
      <SimpleInfo label="LOGRADOURO" value={logradouro} />
      <SimpleInfo label="CÓDIGO POSTAL" value={person?.zipCode || '-'} />
      <SimpleInfo label="BAIRRO" value={person?.district || '-'} />
      <SimpleInfo label="CIDADE" value={person?.city || '-'} />
      <SimpleInfo label="ESTADO" value={person?.state || '-'} />
      <SimpleInfo label="COMPLEMENTO" value={person?.addressComplement || '-'} />
      <SimpleInfo label="RENDA" value={person?.income || '-'} />
      <SimpleInfo label="ESTADO CIVIL" value={maritalStatus} />
    </Grid>
  );
}
